import {SearchOperationsEnum} from "./search-operations.enum";

export interface ISearchFilter {
  modelFieldName:string,
  operation:SearchOperationsEnum,
  filterValue:string
}
export class SearchFilterModel implements ISearchFilter{
  modelFieldName:string;
  operation:SearchOperationsEnum;
  filterValue:string;

  constructor(modelFieldName: string, operation: SearchOperationsEnum, filterValue?: string) {
    this.modelFieldName = modelFieldName;
    this.operation = operation;
    this.filterValue = filterValue;
  }
}
